import React from "react";
import styles from "../assets/propertyGuardianInsurance.module.css";

const PropertyGuardianInsurance = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Securing Your Property With Trusted Guardians
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we understand the importance of keeping your
              property secure and insured. That's why we've partnered with Sona
              Insurance Solutions, a leader in comprehensive insurance services,
              to bring you specialized insurance coverage for buildings occupied
              by guardians.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>
                  Protection and Peace of Mind
                </h4>
                <p className={styles.featureDescription}>
                  Our guardian insurance service is designed to offer robust
                  protection for your property, ensuring it remains secure and
                  well-maintained while occupied. Our guardians are carefully
                  selected to maintain and safeguard your assets.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>
                  Cost-Effective Solutions
                </h4>
                <p className={styles.featureDescription}>
                  Using guardians to protect your property not only enhances
                  security but also significantly reduces the costs associated
                  with empty properties, including reduced insurance premiums
                  and maintenance costs.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Comprehensive Coverage</h4>
                <p className={styles.featureDescription}>
                  In collaboration with Sona Insurance Solutions, we offer a
                  policy that covers all aspects of property guardianship. This
                  includes damage protection, liability coverage, and much more,
                  tailored specifically for properties under guardian care.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>How It Works</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>
                Property Management Software
              </h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Assessment</h4>
                  <p className={styles.serviceDescription}>
                    Contact us to arrange an assessment of your property. We'll
                    evaluate your needs and discuss how our guardian services
                    can be tailored to your specific requirements.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Proposal</h4>
                  <p className={styles.serviceDescription}>
                    Receive a detailed proposal outlining the scope of guardian
                    coverage, including costs, terms, and the benefits of
                    partnering with us.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Coverage Activation</h4>
                  <p className={styles.serviceDescription}>
                    Once you decide to proceed, we'll work with Sona Insurance
                    Solutions to activate your insurance coverage, ensuring a
                    seamless transition and immediate protection.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Contact Us Today</h4>
            <p className={styles.contactDescription}>
              To learn more about our Property Guardian Insurance Service or to
              discuss your property's specific needs, please don't hesitate to
              get in touch:
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:globalguardians@sonainsurance.com">
                globalguardians@sonainsurance.com
              </a>{" "}
              or by phone: 01206 694906
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyGuardianInsurance;
